import { useContext, useEffect } from 'react';
import { useBoxTransfersTableColumns } from '.';
import { BoxTransfersTableContext } from '../../context';
import { TableState } from '@core/table';
import { useLocation } from 'react-router-dom';

export const useTelegramBotUsersTable = () => {
  const { mergeState } = useContext(BoxTransfersTableContext);

  const location = useLocation<{ boxTransfersTable?: { mergeState?: Partial<TableState> } }>();

  const columns = useBoxTransfersTableColumns();

  useEffect(() => {
    if (location.state?.boxTransfersTable?.mergeState) {
      mergeState(location.state.boxTransfersTable.mergeState);
    }
  }, [location.state?.boxTransfersTable?.mergeState, mergeState]);

  return { columns, context: BoxTransfersTableContext };
};
